import axios from "axios";

let tokenFetcher = null;

export const setTokenFetcher = (fetcher) => {
  tokenFetcher = fetcher;
};

const fetchClient = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/vnd.vastu-web-backend.v1",
      "ngrok-skip-browser-warning": "true",
    },
  };

  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async (config) => {
    try {
      if (tokenFetcher) {
        const token = await tokenFetcher();

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (e) {
      console.error("Error fetching Clerk token:", e);
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        const data = error.response.data;
        if (data && data.error_code === "session_displaced") {
          // Clear local credentials
          localStorage.removeItem("access_token");

          // Call Clerk signOut if available globally on window and wait for it to complete
          if (window.Clerk) {
            window.Clerk.signOut().then(() => {
              window.location.href = "/?logout_reason=displaced";
            }).catch((err) => {
              console.error("Clerk signout failed", err);
              window.location.href = "/?logout_reason=displaced";
            });
          } else {
            window.location.href = "/?logout_reason=displaced";
          }
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default fetchClient();
